import { createApp } from 'vue'
import { App as CapacitorApp } from '@capacitor/app'
import App from './App.vue'
import router from './router'
import i18n from './lib/i18n'
import './assets/tailwind.css'
import './registerServiceWorker'

CapacitorApp.addListener('appRestoredResult', (event) => {
  if (event?.pluginId !== 'Camera') return
  window.dispatchEvent(new CustomEvent('drvn:camera-restored', { detail: event }))
})

createApp(App).use(router).use(i18n).mount('#app')
